import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const api = axios.create({ baseURL: API_URL });

/** Comprueba si un JWT está caducado */
export function isJwtExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1] || ""));
        if (!payload?.exp) return true;
        return payload.exp * 1000 <= Date.now();
    } catch {
        return true;
    }
}

/** Devuelve el token válido del localStorage (si caducó, lo limpia y devuelve null) */
export function getValidToken() {
    const t = localStorage.getItem("token");
    if (!t) return null;
    if (isJwtExpired(t)) {
        localStorage.removeItem("token");
        return null;
    }
    return t;
}

/** Convierte una http(s) API URL en ws(s) para el WebSocket */
export function wsUrlFromApi(url = API_URL) {
    try {
        // Si la URL es relativa o no tiene protocolo, usa la ubicación actual
        if (url.startsWith("/") || !url.includes("://")) {
            const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
            return `${proto}//${window.location.host}`;
        }
        const u = new URL(url);
        u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
        return u.toString().replace(/\/$/, "");
    } catch {
        return (url || "").replace(/^http/, "ws").replace(/\/$/, "");
    }
}

// En cada request adjunta Authorization si hay token válido
api.interceptors.request.use((config) => {
    const t = getValidToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

// Si recibe 401, limpia token y redirige a /login (evita bucles con _redirecting)
let _redirecting = false;
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        if (status === 401 && !_redirecting) {
            _redirecting = true;
            try { localStorage.removeItem("token"); } catch {}
            window.location.assign("/login");
        }
        return Promise.reject(err);
    }
);